import { create } from "zustand";

const useStore = create((set) => ({
  openAPKDetails: false,
  webViewEventState: null,
  userData: null,
  showPaymentSuccess: false,
  isUserLoggedIn: false,
  openPaymentModal: false,
  openAllCategories: false,
  allCategoriesListing: [],
  allCategoriesLoading: false,
  paymentMethods: {},
  razorpay: {},
  openCustomPaymentScreen: false,
  isPageRefresh: false,
  glitchLoader: true,
  hasVideoEnded: false,
  openShareModal: false,
  showIphoneBanner: true,
  openDisclaimer: false,
  openQRModal: false,
  setOpenAPKDetails: (val) => set(() => ({ openAPKDetails: val })),
  setWebViewEventState: (val) => set(() => ({ webViewEventState: val })),
  setUserData: (val) => set(() => ({ userData: val })),
  setShowPaymentSuccess: (val) => set({ showPaymentSuccess: val }),
  setIsUserLoggedIn: (val) => set(() => ({ isUserLoggedIn: val })),
  setOpenPaymentModal: (val) => set(() => ({ openPaymentModal: val })),
  setOpenAllCategories: (val) => set(() => ({ openAllCategories: val })),
  setAllCategoriesListing: (val) => set(() => ({ allCategoriesListing: val })),
  setAllCategoriesLoading: (val) => set(() => ({ allCategoriesLoading: val })),
  setPaymentMethods: (val) => set(() => ({ paymentMethods: val })),
  setRazorpay: (val) => set(() => ({ razorpay: val })),
  setOpenCustomPaymentScreen: (val) =>
    set(() => ({ openCustomPaymentScreen: val })),
  setIsPageRefresh: (val) => set(() => ({ isPageRefresh: val })),
  setGlitchLoader: (val) => set(() => ({ glitchLoader: val })),
  setHasVideoEnded: (val) => set(() => ({ hasVideoEnded: val })),
  setOpenShareModal: (val) => set(() => ({ openShareModal: val })),
  setShowIphoneBanner: (val) => set(() => ({ showIphoneBanner: val })),
  setOpenDisclaimer: (val) => set(() => ({ openDisclaimer: val })),
  setOpenQRModal: (val) => set(() => ({ openQRModal: val })),
}));

export default useStore;
